import React from "react"
import Rating from "./Rating"
import Socials from "./Socials"
import { getAverageRating } from "../../util"
import "../styles/ProductDetails.css"

function ProductDetails({ product, children }) {
  if (!product) return null
  console.log(product)
  return (
    <div className="product-container">
      <div className="product-wrapper">
        {product.imageURL && (
          <img
            className="product-image"
            src={product.imageURL}
            alt={product.name}
          />
        )}
        <div className="product-details">
          <h2 className="product-material">{product.material}</h2>
          <h1 className="product-name">{product.name}</h1>
          <div className="product-rating">
            {product.reviews && (
              <Rating rating={getAverageRating(product.reviews)} />
            )}
            {product.id && (
              <span className="product-socials">
                <Socials product={product} />
              </span>
            )}
          </div>
          <span className="product-category">{product.category}</span>
          <p className="product-description">{product.description}</p>
          <div className="product-price-section">
            <span className="product-price">{`$${product.price}`}</span>
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}

export default ProductDetails
